const concatNames = (...names) => names.filter(name => name).join(' ')

export default concatNames
